<!-- Document top -->
<div class="card">
  <div class="card-body">

    <div class="row">
      <!-- Issuer -->
      <div class="col col-md-6">
        <app-document-issuer
          *ngIf="!['write-off', 'warehouse-transfer'].includes(document?.type)"
          [issuer]="document._documentIssuer"
          [unit]="document._documentUnit"
        ></app-document-issuer>
      </div>

      <!-- Logo -->
      <div class="col d-none d-md-block text-right">
        <app-document-view-logo
          *ngIf="document && document.organizationId"
          [organizationId]="document.organizationId"
        ></app-document-view-logo>
      </div>
    </div>

    <div class="row mb-lg-5">
      <!-- Client -->
      <div class='col col-md-6 mt-4'>
        <app-document-view-client [client]='document._documentClient'></app-document-view-client>
        <!-- Warehouse specific info if document is warehouse transfer-->
        <app-document-view-warehouse-transfer [doc]='document' class='row'></app-document-view-warehouse-transfer>
      </div>

      <div class="w-100 d-sm-none"></div>

      <div class="col mt-5 text-sm-right">
        <!-- Status -->
        <app-document-view-status [doc]="document" class="status"></app-document-view-status>

        <!-- Dates and Info -->
        <app-document-view-dates [doc]="document" [locale]="locale" class="row"></app-document-view-dates>
      </div>
    </div>
  </div>

  <!-- Line items -->
  <div class="row mb-5">
    <div class="col">
      <app-document-view-items [document]="document" [locale]="locale"></app-document-view-items>
    </div>
  </div>

  <div class="card-body pt-0">

    <div class="row mb-5">
      <!-- Left -->
      <div class="col order-last order-md-first">
        <!-- Reverse taxes -->
        <app-document-reverse-tax-table
          *ngIf="
            document['_documentReverseTaxes'] &&
            document['_documentReverseTaxes'].length &&
            !['write-off', 'warehouse-transfer'].includes(document.type)
          "
          [currency]="document.currencyId"
          [taxes]="document['_documentReverseTaxes']"
          [locale]="locale"
        >
        </app-document-reverse-tax-table>

        <!-- Referenced docs -->
        <app-document-view-referenced
          class="row"
          [class.mt-3]="document['_documentReverseTaxes']?.length"
          *ngIf="document.documents && document.documents.length"
          [documents]="document.documents"
          [typeName]="typeName | async"
          [link]="false"
        >
        </app-document-view-referenced>

        <!-- Note -->
        <div class="whitespace-pre mb-4">{{ lod(document, 'note') }}</div>

        <!-- Disclaimers ie. for currency conversion etc. -->
        <div class="text-muted whitespace-pre">{{ document['disclaimer'] }}</div>

        <!-- Fiscalization -->
        <!-- FURS -->
        <app-document-view-fiscalization *ngIf="document._furs?.zoi" [document]="document"></app-document-view-fiscalization>
        <app-qr-code *ngIf="document._fina?.JIR" [document]="document"></app-qr-code>

        <!-- Delivery note signature -->
        <div class="" *ngIf="document.type === 'delivery-note'">
          <br />
          <hr class="mb-0 mt-5" />
          <small>{{ 'document-view-public.delivery-note.recipient-signature' | translate }}</small>
        </div>

      </div>

      <div class="w-100 d-md-none"></div>

      <!-- Right -->
      <div class="col col-lg-5 col-xl-4 order-first order-md-last mb-5">
        <!-- Totals -->
        <app-document-totals-table
          class="justify-content-end"
          [currency]="document.currencyId"
          [inForeignCurrency]="!!document._documentConversionRate"
          [items]="document._documentItems"
          [totalDiscount]="document.totalDiscount"
          [taxes]="document['_documentTaxes']"
          [total]="document.total"
          [totalWithTax]="document.totalWithTax"
          [locale]="locale"
          [equalizationValue]="document.equalization"
          *ngIf="!['write-off', 'warehouse-transfer'].includes(document.type)"
        >
        </app-document-totals-table>

        <!-- Payments -->
        <app-document-view-payments
          *ngIf="document.payments?.length"
          [payments]="document.payments"
          [currencyId]="document.currencyId"
          [paidInFull]="document.paidInFull"
        ></app-document-view-payments>

        <!-- Payment QR -->
        <app-payment-qr
          id="payment-qr"
          addClass="text-center text-sm-right mt-0"
          *ngIf="paymentQR"
          [show]="paymentQRVisible"
          [document]="document"
        ></app-payment-qr>

        <!-- Signature -->
        <div class="whitespace-pre text-right mt-5">
          {{ lod(document, 'signature') }}
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col whitespace-pre text-muted text-center">
        {{ lod(document, 'footer') }}
      </div>
    </div>
  </div>
</div>
